import { red } from "@material-ui/core/colors";
import { createMuiTheme } from "@material-ui/core/styles";

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#52bad1",
    },
    secondary: {
      main: "#dff0f4",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#f2f7f9",
    },
  },
});

export default theme;
